import { Sport } from '@sorare/core/src/__generated__/globalTypes';
import { useSportContext } from '@sorare/core/src/contexts/sport';

import bundesligaBackgroundWide from './assets/background-bundesliga-wide.webp';
import bundesligaBackground from './assets/background-bundesliga.webp';
import laligaBackgroundWide from './assets/background-laliga-wide.webp';
import laligaBackground from './assets/background-laliga.webp';
import ligue1BackgroundWide from './assets/background-ligue1-wide.webp';
import ligue1Background from './assets/background-ligue1.webp';
import nbaBackgroundWide from './assets/background-nba-wide.webp';
import nbaBackground from './assets/background-nba.webp';
import plBackgroundWide from './assets/background-pl-wide.webp';
import plBackground from './assets/background-pl.webp';
import sorareBackgroundWide from './assets/background-sorare-wide.webp';
import sorareBackground from './assets/background-sorare.webp';

const PACK_ASSETS: Record<
  string,
  { background: string; backgroundWide: string }
> = {
  'premier-league-gb-eng': {
    background: plBackground,
    backgroundWide: plBackgroundWide,
  },
  'laliga-es': {
    background: laligaBackground,
    backgroundWide: laligaBackgroundWide,
  },
  'bundesliga-de': {
    background: bundesligaBackground,
    backgroundWide: bundesligaBackgroundWide,
  },
  'ligue-1-fr': {
    background: ligue1Background,
    backgroundWide: ligue1BackgroundWide,
  },
  sorare: {
    background: sorareBackground,
    backgroundWide: sorareBackgroundWide,
  },
  nba: {
    background: nbaBackground,
    backgroundWide: nbaBackgroundWide,
  },
};

export const usePackAssets = ({
  cardPackGroupId,
}: {
  cardPackGroupId: Nullable<string>;
}) => {
  const { sport } = useSportContext();
  let bgImage =
    PACK_ASSETS[cardPackGroupId || 'sorare']?.background ||
    PACK_ASSETS.sorare.background;
  let bgImageWide =
    PACK_ASSETS[cardPackGroupId || 'sorare']?.backgroundWide ||
    PACK_ASSETS.sorare.backgroundWide;

  if (sport === Sport.NBA) {
    bgImage = PACK_ASSETS.nba.background;
    bgImageWide = PACK_ASSETS.nba.backgroundWide;
  }
  return { bgImage, bgImageWide };
};
